import { Box, Typography } from "@mui/material"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import theme from "src/theme/light"

export interface PremissasPaybackProps {
    instalacao: boolean
  }
export function PremissasPayback({ instalacao = false }: PremissasPaybackProps){
    return (
      <Box style={{paddingTop:"10px"}}>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * O payback foi calculado tendo como referência o preço do gerador fotovoltaico com pagamento à vista, desconsiderando taxas de juros e outros custos decorrentes de financiamento.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Considerando um aumento anual médio na tarifa de energia elétrica de 6,00%.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Considerando performance conforme disponibilizado no datasheet do módulo fotovoltaico, sendo a garantia de desempenho mínimo de 84,8% do seu desempenho nominal no 25° ano de operação.            
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Cálculo considerando as alterações propostas na REN 1.059/2023, Lei 14.300/22 e REN 1.000/21 da ANEEL.          
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * A Tarifa de energia elétrica é baseada nos dados disponibilizados pela Aneel, para cada concessionária ou permissionária de distribuição de energia elétrica.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Esses valores são de referência e podem variar considerando condições climáticas, ajustes tarifários e fiscais.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Os cálculos já consideram a taxa mínima da concessionária (Custo de disponibilidade = valor cobrado pela concessionária mesmo que o consumo de energia elétrica seja zero).
        </Typography>
        { !instalacao && (
            <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
                * Este cálculo não está considerando o valor da instalação.
            </Typography>
        )}
      </Box>
    )
  }